const setRootSize = (): void => {
  const rootHtml: HTMLElement = document.documentElement;
  const clientWidth: number = rootHtml.clientWidth;
  const rootSize: number = clientWidth <= 750 ? clientWidth / 7.5 : 100;
  rootHtml.style.fontSize = `${rootSize}px`;
};

window.addEventListener('resize', setRootSize);

setRootSize();
